import { render, staticRenderFns } from "./FormPlus.vue?vue&type=template&id=01c5b88c&scoped=true"
import script from "./FormPlus.vue?vue&type=script&lang=js"
export * from "./FormPlus.vue?vue&type=script&lang=js"
import style0 from "./FormPlus.vue?vue&type=style&index=0&id=01c5b88c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c5b88c",
  null
  
)

export default component.exports